import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import styled from "styled-components";

export const PageContainer = styled.div`
	background-color: ${({ bgColor, theme }) => (bgColor ? bgColor : theme.colors.white)};
	padding: 2rem 3rem;

	padding-top: ${({ paddingtop }) => (paddingtop ? paddingtop : "")};

	${media.lessThan(breakpoints.ipad)`
  padding: 1em 1rem;
	padding-top: ${({ paddingtop }) => (paddingtop ? paddingtop : "")};
  
  `}
	${media.lessThan(breakpoints.mobile)`
  padding: 1rem 0;
	padding-top: ${({ paddingtop }) => (paddingtop ? paddingtop : "")};

  `}
`;
